module.exports = __webpack_public_path__ + "img/faq-grid-04.d301ffcb.png";